import { Component, OnDestroy, OnInit } from "@angular/core";
import { EmpList, projectDetails, projectList } from "../../admin.interface";
import { AddProjectService } from "./add-project.service";
import { IMyOptions, IMyDateModel } from "mydatepicker";
import { ActivatedRoute, Router } from "@angular/router";
import { MatSnackBar } from "@angular/material";
import { DeletePopUpComponent } from "../../../common/delete-pop-up/delete-pop-up.component";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { SessionStorage } from "ngx-webstorage";
import { UploadHistoryComponent } from "../../../common/upload-history/upload-history.component";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { ExportExcelService } from "../../../utils/services/export-excel.service";
import { Observable } from "rxjs/Observable";
import { FormControl } from "@angular/forms";
import { ProjectService } from "../project.service";
import { TimesheetEntryService } from "../../../employee/timesheet-entry/timesheet-entry.service";
import { DropDownMasterProject } from "../../../employee/employee.interface";
import { type } from "os";

@Component({
  selector: "app-add-project",
  templateUrl: "./add-project.component.html",
  styleUrls: ["./add-project.component.css"],
})
export class AddProjectComponent implements OnInit, OnDestroy {
  public projectDetails: projectDetails = new projectDetails("");
  @SessionStorage() public user;

  @SessionStorage() public config;

  public projectList: any = [];
  public employeeList: any = [];
  public allEmployeeList: any = [];
  public newEmployeeList: any = [];
  public selectedEmployee: any = [];
  public submitted = false;
  public myDatePickerOptions: IMyOptions;
  public myDatePickerEndOptions: IMyOptions;
  public projectListArray: any = [];
  public addErrors: string;
  public fileName: any;
  public backupData: string;
  public checkDuplicate = false;
  public selectedProject: any;
  private alive: boolean = true;
  private projId: string;
  private isEdit: boolean = false;
  private projectListObj: any = {};
  private searchLoader: boolean = false;
  private projectLoader = true;
  private teamLeadLoader: Number = null;
  private groupLeadLoader: Number = null;
  private inValidEmp = false;
  private inValidTLorGL = false;
  private employess = "";
  public departmentOptions:any[];
  constructor(
    private timesheetEntryService: TimesheetEntryService,
    private addProjectService: AddProjectService,
   // private ReportsService:ReportsService,
    private router: Router,
    private activeRouter: ActivatedRoute,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private spinnerService: Ng4LoadingSpinnerService,
    private exportExcel: ExportExcelService
  ) {
    this.myDatePickerOptions = {
      dateFormat: "dd-mm-yyyy",
      markCurrentDay: true,
      disableHeaderButtons: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: false,
    };
    this.myDatePickerEndOptions = {
      dateFormat: "dd-mm-yyyy",
      markCurrentDay: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: false,
      inline: false,
    };
  }
  filteredProject: Observable<any[]>;
  filteredEmployee: Observable<any[]>;
  addDepartment: boolean = false;

  ngOnInit() {
    if (this.user.businessUnit === "cdmo"){
      this.departmentOptions= ["PR&D", "AR&D", "PE", "FR&D", "FAR&D"];
      }
      else if(this.user.businessUnit=="discovery"){
      this.departmentOptions = ["Analytical R&D-GLP","PR&D", "AR&D","AR&D-Med Chem","CADD & Informatics", "PE","FR&D","FAR&D","Immuno Oncology","Invitro Biology","Medical Chemistry","Micro biology","NBE Services","Oligo nucleotides","Peptide Chemistry","Pharmacology","Toxicology","Protac","Discovery Chemistry","Biology","Chemistry","DMPK","Integrated Discovery","NBE"];
      }


    this.getProjectLists();
    this.getAllEmployees();

    this.projId = this.activeRouter.snapshot.paramMap.get("id");
    if (this.projId) {
      this.isEdit = true;
      this.projectLoader = false;
      this.getProjectInfo(this.projId);
    } else {
      this.projectDetails.departmentInfo = [
        { department: "", plannedHrs: "", teamLead: "", groupLead: ""},
      ];
    }
  }
  // Function get Project info
  getProjectInfo(id) {
    this.addProjectService.getProjectInfo(id).subscribe((p) => {
      let projectInfo = p.payload.Project;
      let dataInfo = {
        employees: p.payload.empDetails,
        departmentInfo: p.payload.Project.departmentInfo
          ? p.payload.Project.departmentInfo
          : [{ department: "", plannedHrs: "", teamLead: "", groupLead: ""}],
        total: p.payload.totalTimePerproject,
      };
      this.setProject(projectInfo, dataInfo);
    });
  }

  // Add Department validation
  formIsValid(addProjForm, method): boolean {
    if (this.projectDetails.departmentInfo.length > 1 || method != "submit") {
      for (const field of this.projectDetails.departmentInfo) {
        if (field.department === "") {
          return false;
        }
        else if (field.teamLead !== "" || field.groupLead !== "") {
          const teamLeadValid = this.checkEmployeeAvilablity(field.teamLead);
          const groupLeadValid = this.checkEmployeeAvilablity(field.groupLead);

          // Set custom errors for teamLead and groupLead controls if invalid
          if (!teamLeadValid) {
            this.inValidTLorGL = true;
            addProjForm.form.controls[
              this.projectDetails.departmentInfo.indexOf(field)
            ].controls["teamLead"].setErrors({ customError: true });
          } else {
            this.inValidTLorGL = false;
            addProjForm.form.controls[
              this.projectDetails.departmentInfo.indexOf(field)
            ].controls["teamLead"].setErrors(null);
          }

          if (!groupLeadValid) {
            addProjForm.form.controls[
              this.projectDetails.departmentInfo.indexOf(field)
            ].controls["groupLead"].setErrors({ customError: true });
            this.inValidTLorGL = true;
          } else {
            this.inValidTLorGL = false;
            addProjForm.form.controls[
              this.projectDetails.departmentInfo.indexOf(field)
            ].controls["groupLead"].setErrors(null);
          }

          // Return false if either teamLead or groupLead is invalid
          if (!teamLeadValid || !groupLeadValid) {
            return false;
          }
        }
      }
    }

    return true;
  }

  // Add Deapartment
  addDepat(a) {
    this.addDepartment = true;
    if (this.formIsValid(a, "add")) {
      const hasDuplicates = this.hasDuplicateDepartments(
        this.projectDetails.departmentInfo
      );

      if (hasDuplicates.length == 0) {
        this.projectDetails.departmentInfo.push({
          department: "",
          plannedHrs: "",
          teamLead: "",
          groupLead: ""
        });
      } else {
        this.snackBar.open(
          `The ${hasDuplicates} department has already been added.`,
          "Okay",
          {
            duration: 3000,
          }
        );
      }
    } else {
      this.snackBar.open(`Please Select Department`, "Okay", {
        duration: 3000,
      });
    }
  }
  // check duplicate Department
  hasDuplicateDepartments(array) {
    const departmentSet = new Set();
    const duplicateDepartments = [];

    for (const item of array) {
      if (departmentSet.has(item.department)) {
        duplicateDepartments.push(item.department);
      } else {
        departmentSet.add(item.department);
      }
    }

    return duplicateDepartments;
  }

  // delete Deapartment
  deleteDepat(i) {
    let plannedHrs = this.projectDetails.departmentInfo[i].plannedHrs;
    this.projectDetails.plannedHours =
      this.projectDetails.plannedHours - plannedHrs;
    this.projectDetails.departmentInfo.splice(i, 1);
  }

  // track Form group
  trackByFn(index: number, item: any): any {
    return index;
  }

  updateIndexes() {
    this.projectDetails.departmentInfo.forEach((control, index) => {
      control["index"] = index;
    });
  }
  // sum of department planned hours
  hoursChanges(event) {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value;
    const sanitizedValue = inputValue.replace(/[^0-9.-]/g, "");
    const sanitizedValueWithoutDoubleMinus = sanitizedValue.replace(/--/g, "-");
    inputElement.value = sanitizedValueWithoutDoubleMinus;
    let plannedHrs = this.projectDetails.departmentInfo.reduce(
      (acc, pre) => acc + pre.plannedHrs,
      0
    );
    this.projectDetails.plannedHours = plannedHrs;
  }

  // Function stringToDateFormat
  stringToDateFormat(d: string) {
    let date = new Date(d);
    return {
      date: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      },
    };
  }

  stringToDateFormatt(d: string) {
    let date = new Date(d);
    date.setUTCHours(0, 0, 0, 0);

    return {
      date: {
        year: date.getUTCFullYear(),
        month: date.getUTCMonth() + 1,
        day: date.getUTCDate(),

      },
    };
  }



  // New Function to add filled project
  onSubmit(addProjForm) {
   console.log("project edited successfully");
    this.submitted = true;

    if (addProjForm.valid && this.formIsValid(addProjForm, "submit")) {
      const hasDuplicates = this.hasDuplicateDepartments(
        this.projectDetails.departmentInfo
      );
      if (hasDuplicates.length == 0) {
        this.checkDuplicate = false;
        this.projectList
          .filter(
            (ele, j) => ele.projectName == this.projectDetails.projectName
          )
          .map((ele) => (this.checkDuplicate = true));
        if (this.checkDuplicate) {
          let currentDate = new Date();
          console.log(currentDate.getFullYear());
          const userObj = {
            Empno: this.user.Empno,
            Empname: this.user.Empname,
            EmailID: this.user.EmailID,
            Role: this.user.Role,
            BusinessUnit: this.user.businessUnit,
          };
          this.projectDetails.employess = this.selectedEmployee;
          const data = {
            project: {
              projectID: this.selectedProject.projectID,
              Project: this.projectDetails.projectName,
              wbsCode: this.projectDetails.wbsCode,
              startDate: this.getEventDate(this.projectDetails.startDate),
              endDate: this.getEventDate(this.projectDetails.endDate),
              departmentInfo: this.projectDetails.departmentInfo,
              plannedHour: this.projectDetails.plannedHours,
              projectType: this.projectDetails.projectType,
              projectManager: this.projectDetails.projectManager,
              userObj: userObj,
            },
            employess: this.projectDetails.employess,
          };
          this.spinnerService.show();
          if (this.isEdit) {
            this.addProjectService.updateProject(data).subscribe(
              (response) => {
                this.spinnerService.hide();
                this.snackBar.open("Project Updated Successfully", "Okay", {
                  duration: 3000,
                });
                this.addProjectService.triggerAPI(this.selectedProject).subscribe((response)=>{
                  const responseBody = JSON.parse(response._body); // Parse the _body property as JSON
                  const message = responseBody.Message; // Access the Message field from the parsed JSON
                  console.log(message); // Output: hello
                 this.snackBar.open("Response From Control Panel: " + message, "OK", {
                 duration: 60000,
                  });
                  },
                  (error) => {
                    console.error("Error triggering API:", error);
                    this.snackBar.open("Error triggering API", "OK", {
                      duration: 3000,
                    });
                  }
                );

                //this.backToProject();
              },
              (err) => {
                if (err) {
                  this.snackBar.open(err.error.message, "Okay", {
                    duration: 3000,
                  });
                }
                this.spinnerService.hide();
              }
            );
          } else {
            this.addProjectService.addProject(data).subscribe(
              (response) => {
                this.spinnerService.hide();
                this.snackBar.open("Project Added Successfully", "Okay", {
                  duration: 3000,
                });
                this.backToProject();
              },
              (err) => {
                if (err) {
                  this.snackBar.open(err.error.message, "Okay", {
                    duration: 3000,
                  });
                }
                this.spinnerService.hide();
              }
            );
          }
        }
      } else {
        this.snackBar.open(
          `The ${hasDuplicates} department has already been added.`,
          "Okay",
          {
            duration: 3000,
          }
        );
      }
    } else {
      this.snackBar.open(`Please Select Department`, "Okay", {
        duration: 3000,
      });
    }
  }

//   getProjectDetails() {
//     this.projectListArray = [];
//     this.ReportsService.getProjectList().subscribe((data) => {
//       console.log(data.payload.projects,"12345");
//       if(data.payload.projects && data.payload.projects.length > 0){
//       data.payload.projects.forEach((value) => {
//         console.log(data,"mydata");
//         this.projectListArray.push(new ProjectData(value));
//       });
//     }
//     });
//     this.ReportsService.postProjectData(this.projectListArray).subscribe(
//       (response) => {
//         console.log(response,"this is my response");
//       },
//       (err) => {
//         if (err) {
//           console.log(err);
//         }
//   });
//  }
  // Function Change the DateFormat
  changeTheDateFormat(data: any) {
    return data
      ? new Date(data.date.year, data.date.month - 1, data.date.day).getTime()
      : "";
  }

  //Function to get event date
  getEventDate(selectedDate: any) {
    if (selectedDate.date) {
      return `${selectedDate.date.year}-${selectedDate.date.month}-${selectedDate.date.day}`;
    } else if (selectedDate.formatted) {
      return selectedDate.formatted;
    } else {
      return;
    }
  }

  //Function to go back to project
  backToProject() {
    this.router.navigate(["/admin/project"]);
  }

  //Function to set validation for start date
  startDate() {
    this.myDatePickerEndOptions = {
      dateFormat: "dd-mm-yyyy",
      markCurrentDay: true,
      disableHeaderButtons: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: false,
      inline: false,
      disableUntil: {
        year: this.projectDetails.startDate.date.year,
        month: this.projectDetails.startDate.date.month,
        day: this.projectDetails.startDate.date.day,
      },
    };
  }

  /* Get All Employees */
  getAllEmployees() {
    this.addProjectService.getEmployeesDetails("").subscribe(
      (response) => {
        if (response.payload) {
          response.payload.map((value) => {
            if (
              this.allEmployeeList.filter(
                (e) => e.Empno == value.employeeDetails.Empno
              ).length == 0
            ) {
              this.allEmployeeList.push(value.employeeDetails);
            }
          });
        }
      },
      (error) => {
        this.snackBar.open("No Employee list found", "", {
          duration: 3000,
        });
      }
    );
  }
  /* Get search Employees */
  getEmployeeDetails(s: any, type, i) {
    this.employeeList = [];
    this.newEmployeeList = [];
    let searchText = s;
    if (searchText.length >= 2) {
      if (type == "tl") {
        this.teamLeadLoader = i;
      } else if (type == "gl") {
        this.groupLeadLoader = i;
      }
      this.addProjectService
        .getEmployeesDetails(searchText.trim())
        .takeWhile(() => this.alive)
        .subscribe(
          (response) => {
            if (response.payload) {
              if (type == "tl") {
                this.teamLeadLoader = null;
              } else if (type == "gl") {
                this.groupLeadLoader = null;
              }
              response.payload.map((value) => {
                if (
                  this.employeeList.filter(
                    (e) => e.Empno == value.employeeDetails.Empno
                  ).length == 0
                ) {
                  this.employeeList.push(value.employeeDetails);
                }
                if (
                  this.newEmployeeList.filter(
                    (e) => e.Empno == value.employeeDetails.Empno
                  ).length == 0
                ) {
                  this.newEmployeeList.push(value.employeeDetails);
                }
              });
            }
          },
          (error) => {
            this.snackBar.open("No Employee list found", "", {
              duration: 3000,
            });
          }
        );
    }
  }

  /* Filter Employee */
  filterEmployee(event: any) {
    const searchItem = event.target.value;
    console.log(JSON.stringify(this.employeeList.length) + "  " + searchItem);

    let arr = this.employeeList.filter((e) => {
      if (
        e.employeeDetails.Empname.toLowerCase().indexOf(
          searchItem.toLowerCase()
        ) === 0
      ) {
        return true;
      }
      return false;
    });

    this.filteredEmployee = arr;

    return arr.length ? arr : [{ name: "No Item found", code: "null" }];
  }

  // set Employee
  setEmployees(select: any, m: string) {
    console.log(select.option.value);
     if (!m) {
      this.projectDetails.empName = select.option.value.split('(')[0].trim();
    }
    this.newEmployeeList = [];
  }

  setEmployeesforEmp(select: any, m: string) {
    if (!m) {
      this.projectDetails.empName = select.option.value;
    }
    this.newEmployeeList = [];
  }



  // checkEmployeeAvilablity(emp) {
  //   let data = this.allEmployeeList.find((e) => {
  //     const empnameBeforeParan = e.Empname.split('(')[0].trim();
  //     console.log(emp.split('(')[0].trim(),empnameBeforeParan);
  //     return empnameBeforeParan === emp.split('(')[0].trim();
  //   });

  //   if (data) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  // checkEmployeeAvilablity(emp) {
  //   let empID = emp.match(/\(([^)]+)\)/)[1]; // Extract employee ID
  //   let data = this.allEmployeeList.find((e) => {
  //     return e.Empno_legacy === empID;
  //   });

  //   return data ? true : false; // Simplified return statement
  // }
  checkEmployeeAvilablity(emp) {
    let empID = emp.match(/\(([^)]+)\)/)[1]; // Extract employee ID
    let found = false; // Assume employee is not found initially

    for (let e of this.allEmployeeList) {
      if (e.Empno_legacy === empID) {
        found = true; // Set found to true if employee is found
        break; // No need to continue searching
      }
    }

    return found; // Return true if employee is found, otherwise false
  }



  /* add Employee */
  addEmployees() {
    debugger;
    let data = this.allEmployeeList.find(
      (e) => e.Empname == this.projectDetails.empName
    );

    if (data) {
      let empData = this.selectedEmployee.filter((e) => e.Empno == data.Empno);
      if (empData.length == 0) {
        this.selectedEmployee.push(data);
      } else {
        if (empData[0].isDeleted == true) {
          this.selectedEmployee.map((e) =>
            e.Empno == empData[0].Empno ? (e.isDeleted = false) : e
          );
        } else {
          this.snackBar.open("Employee already added", "Okay", {
            duration: 3000,
          });
        }
      }
      this.inValidEmp = false;
      this.projectDetails.empName = "";
    } else {
      this.inValidEmp = true;
    }

    this.employeeList = [];
  }

  // delete Emoloyee
  deleteEmployee(emp: any) {
    if (this.isEdit) {
      emp.isDeleted = true;
    } else {
      const index = this.selectedEmployee.findIndex(
        (e) => e.Empno === emp.Empno
      );
      if (index !== -1) {
        this.selectedEmployee.splice(index, 1);
      }
    }
  }

  /**function to get project details*/
  getProjectLists() {
    this.projectList = [];
    this.addProjectService.getAllMasterProjects().subscribe((data) => {
      this.projectLoader = false;
      data.payload
        .filter((value) => value)
        .map((ele) => {
          this.projectListObj[ele.project_id] = new DropDownMasterProject(ele);
          this.projectList.push(new DropDownMasterProject(ele));
        });
    });
  }

  // Filter Project
  filterProject(event: any) {
    const searchItem = event.target.value;

    let arr = this.projectList.filter(
      (p) => p.projectName.toLowerCase().indexOf(searchItem.toLowerCase()) === 0
    );
    this.filteredProject = arr;
    if (searchItem.length < 1) {
      this.projectDetails.projectManager = "";
      this.projectDetails.startDate = "";
      this.projectDetails.endDate = "";
      this.projectDetails.projectType = "";
      this.projectDetails.plannedHours = "";
      this.projectDetails.wbsCode = "";
      this.selectedEmployee = [];
    }
    return arr.length ? arr : [{ name: "No Item found", code: "null" }];
  }
  // selectProject
  selecteProject(selected: any) {

   // const project = this.projectListObj[selected.option.value];
    const project = this.projectList.find(a => a.projectName === selected.option.value);

    this.setProject(project, null);
  }
  // Set Project
  setProject(project: any, dataInfo: any) {
    this.selectedProject = project;
    this.projectDetails.projectName = project.projectName;
    this.projectDetails.projectManager = project.projectManager;
    this.projectDetails.startDate = project.startDate
      ? this.stringToDateFormatt(project.startDate)
      : "";
    this.projectDetails.endDate = project.endDate
      ? this.stringToDateFormatt(project.endDate)
      : "";
    this.projectDetails.plannedHours = project.plannedHour;

    this.projectDetails.projectType = project.projectType;
    this.projectDetails.wbsCode = project.wbsCode;

    if (dataInfo) {
      this.projectDetails.actualHours =
        dataInfo.total != null ? parseInt(dataInfo.total) : 0;
      this.projectDetails.projectName = project.Project;

      dataInfo.departmentInfo.forEach((e) => {
        this.projectDetails.departmentInfo.push(e);
      });

      dataInfo.employees.forEach((e) => {
        e.empdetails.isDeleted = false;
        this.selectedEmployee.push(e.empdetails);
      });
    }
  }

  //Function to edit project
  editProject(index) {
    if (!this.checkDuplicate) {
      this.projectList[index].editMode = !this.projectList[index].editMode;
      this.projectList[index].startDate = this.getEventDate(
        this.projectList[index].originalstartDate
      );
      this.projectList[index].endDate = this.getEventDate(
        this.projectList[index].originalendDate
      );
      for (let i = 0; i <= this.projectList.length - 1; i++) {
        if (i != index && this.projectList[i].editMode == true) {
          this.projectList[i].editMode = false;
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/project/add-project/add-project.component.ts